export const CLOUDINARY_MAX_FILE_SIZE_MB = 10;
export const CLOUDINARY_MAX_FILE_SIZE_BYTES = CLOUDINARY_MAX_FILE_SIZE_MB * 1024 * 1024;

export const scanTooLargeMessage = (file: File, sizeInMb: string) =>
  `Plik „${file.name}” jest za duży (${sizeInMb} MB). Maksymalny rozmiar pojedynczego pliku to ${CLOUDINARY_MAX_FILE_SIZE_MB} MB. Podziel go na kilka mniejszych plików i dodaj je osobno.`;

export const singleFileTooLargeMessage = (file: File, sizeInMb: string) =>
  `Plik „${file.name}” jest za duży (${sizeInMb} MB). Maksymalny rozmiar pliku to ${CLOUDINARY_MAX_FILE_SIZE_MB} MB. Wybierz mniejszy plik.`;
